import { useEffect } from 'react';

var useScrollSync = function (sourceRef, targetRef, enabled) {
    if (enabled === void 0) { enabled = true; }
    useEffect(function () {
        if (!sourceRef.current || !targetRef.current || !enabled) {
            return;
        }
        var sourceElement = sourceRef === null || sourceRef === void 0 ? void 0 : sourceRef.current;
        var targetElement = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
        var handleScroll = function (source, target) {
            if (source && target) {
                target.scrollLeft = source.scrollLeft;
            }
        };
        var syncScroll1 = function () { return handleScroll(sourceElement, targetElement); };
        var syncScroll2 = function () { return handleScroll(targetElement, sourceElement); };
        if (sourceElement && targetElement) {
            sourceElement.addEventListener("scroll", syncScroll1);
            targetElement.addEventListener("scroll", syncScroll2);
        }
        return function () {
            if (sourceElement && targetElement) {
                sourceElement.removeEventListener("scroll", syncScroll1);
                targetElement.removeEventListener("scroll", syncScroll2);
            }
        };
    }, [enabled, sourceRef, targetRef]);
};

export { useScrollSync as u };
//# sourceMappingURL=useScrollSync-b2d28bed.js.map
